// eslint-disable-next-line import/no-extraneous-dependencies
import { createBrowserHistory } from 'history';

/**
 * A history object to be placed into the router.
 */
const routerHistory = createBrowserHistory();
export default routerHistory;
